import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import {colors} from 'shells/colors/colors';
import {ErrorMessage} from 'shells/form/error-message';
// @ts-expect-error - imported from .js/.jsx file
import {CloseIcon} from 'shells/icon/svg/close-icon';
// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';
import {ModalLightbox} from 'shells/modal/modal-lightbox';

import type {
    GetMessageBody as GetMessageBodyQuery,
    GetMessageBodyVariables as GetMessageBodyQueryVariables,
} from 'nutshell-graphql-types';

import GET_MESSAGE_BODY_QUERY from '../graphql/queries/get-message-body.graphql';

import styles from './message-body-preview-modal.module.css';

type Props = {
    onClose: () => any;
    emailTemplateId: string;
    entityId: string;
};

export function MessageBodyPreviewModal(props: Props) {
    const {data, loading, error} = useQuery<GetMessageBodyQuery, GetMessageBodyQueryVariables>(
        GET_MESSAGE_BODY_QUERY,
        {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network',
            variables: {
                emailTemplateId: props.emailTemplateId,
                entityId: props.entityId,
            },
        }
    );

    const {materializedEmailTemplate} = makeDataDangerous(data);

    return (
        <ModalLightbox onClose={props.onClose}>
            <div className={styles['modal-container']}>
                <button onClick={props.onClose} data-tip='Close'>
                    <CloseIcon size={17} />
                </button>
                <div className={styles['message-preview']}>
                    {loading ? (
                        <div className={styles.loading}>
                            <LoadingIcon fill={colors.greyLt} />
                        </div>
                    ) : null}
                    {error ? (
                        <div className={styles.error}>
                            <ErrorMessage>
                                Whoops! We couldn’t load that message, something went wrong.
                            </ErrorMessage>
                        </div>
                    ) : null}
                    {!loading && !error ? (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: materializedEmailTemplate.body,
                            }}
                            className={styles['message-content']}
                        />
                    ) : null}
                </div>
            </div>
        </ModalLightbox>
    );
}
